import Devices from "../Devices/Devices"

const UsbEnabledDevices = () => (
  <Devices
    preset={{ usb: "Enabled" }}
    locked={["usb"]}
    title="USB enabled devices"
  />
)

export default UsbEnabledDevices
